import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import WizardError from "../auth/register/WizardError";
import {
  VENEZUELA_LOCATIONS,
  getLocationOptions,
  getVenezuelaCities,
} from "../../helpers/data/venezuelaLocations";

const CondominiumLocationFields = ({
  state,
  city,
  onStateChange,
  onCityChange,
  stateInputRef,
  cityInputRef,
  stateError,
  cityError,
  required = false,
}) => (
  <Row form>
    <Col sm tag={FormGroup}>
      <Label for="state">
        Estado
        {required && <span className="text-danger ml-1">*</span>}
      </Label>
      <Input
        type="select"
        name="state"
        id="state"
        value={state}
        onChange={(event) => onStateChange(event.target.value)}
        innerRef={stateInputRef}
        className={stateError ? "border-danger" : ""}
        invalid={Boolean(stateError)}
      >
        <option value="">Seleccione un estado</option>
        {getLocationOptions(Object.keys(VENEZUELA_LOCATIONS), state).map((name) => (
          <option key={name} value={name}>{name}</option>
        ))}
      </Input>
      <WizardError
        error={stateError}
        className="fs--1 font-weight-normal d-block"
      />
    </Col>
    <Col sm tag={FormGroup}>
      <Label for="city">
        Ciudad
        {required && <span className="text-danger ml-1">*</span>}
      </Label>
      <Input
        type="select"
        name="city"
        id="city"
        value={city}
        disabled={!state}
        onChange={(event) => onCityChange(event.target.value)}
        innerRef={cityInputRef}
        className={cityError ? "border-danger" : ""}
        invalid={Boolean(cityError)}
      >
        <option value="">
          {state ? "Seleccione una ciudad" : "Seleccione primero un estado"}
        </option>
        {getLocationOptions(getVenezuelaCities(state), city).map((name) => (
          <option key={name} value={name}>{name}</option>
        ))}
      </Input>
      <WizardError
        error={cityError}
        className="fs--1 font-weight-normal d-block"
      />
    </Col>
  </Row>
);

export default CondominiumLocationFields;
